/**
 * Script is forked from cookieconsent.js https://github.com/silktide/cookieconsent2/
 * -> Removed their <a> to their site
 * -> Removed theme loading from CDN
 * -> Added extra HTML markup for flexbox
 * -> Removed Read more if there is no link
 * -> Added disappearing animation
 * -> Uses localStorage instead of cookies
 */

(function () {
  // Stop from running again, if accidently included more than once.
  if (window.hasCookieConsent) return;
  window.hasCookieConsent = true;

  /*
   Constants
   */

  // Client variable which may be present containing options to override with
  var OPTIONS_VARIABLE = 'cookieconsent_options';

  // Change cookie consent options on the fly.
  var OPTIONS_UPDATER = 'update_cookieconsent_options';

  // Name of stored data to be set when dismissed
  var MESSAGE_DISMISSED = 'cookieconsent_dismissed';

  // No point going further if they've already dismissed.
  try {
    if (window.localStorage.getItem(MESSAGE_DISMISSED)) {
      return;
    }
  } catch (e) {
    // localStorage not available
  }

  // IE8...
  if(typeof String.prototype.trim !== 'function') {
    String.prototype.trim = function() {
      return this.replace(/^\s+|\s+$/g, '');
    };
  }

  /*
  Helper methods
  */
 var Util = {
   isArray: function (obj) {
     var proto = Object.prototype.toString.call(obj);
     return proto == '[object Array]';
    },

    isObject: function (obj) {
      return Object.prototype.toString.call(obj) == '[object Object]';
    },

    each: function (arr, callback, /* optional: */context, force) {
      if (Util.isObject(arr) && !force) {
        for (var key in arr) {
          if (arr.hasOwnProperty(key)) {
            callback.call(context, arr[key], key, arr);
          }
        }
      } else {
        for (var i = 0, ii = arr.length; i < ii; i++) {
          callback.call(context, arr[i], i, arr);
        }
      }
    },

    merge: function (obj1, obj2) {
      if (!obj1) return;
      Util.each(obj2, function (val, key) {
        if (Util.isObject(val) && Util.isObject(obj1[key])) {
          Util.merge(obj1[key], val);
        } else {
          obj1[key] = val;
        }
      })
    },

    bind: function (func, context) {
      return function () {
        return func.apply(context, arguments);
      };
    },

    /*
    find a property based on a . separated path.
    i.e. queryObject({details: {name: 'Adam'}}, 'details.name') // -> 'Adam'
    returns null if not found
    */
   queryObject: function (object, query) {
     var queryPart;
     var i = 0;
     var head = object;
     query = query.split('.');
     while ( (queryPart = query[i++]) && head.hasOwnProperty(queryPart) && (head = head[queryPart]) )  {
       if (i === query.length) return head;
      }
      return null;
    },

    setLocalStorage: function (name, value) {
      try {
        window.localStorage.setItem(name, value);
      } catch (e) {
        // localStorage not available
      }
    },

    addEventListener: function (el, event, eventListener) {
      if (el.addEventListener) {
        el.addEventListener(event, eventListener);
      } else {
        el.attachEvent('on' + event, eventListener);
      }
    }
  };

  var DomBuilder = (function () {
    /*
    The attribute we store events in.
    */
    var eventAttribute = 'data-cc-event';
    var conditionAttribute = 'data-cc-if';

    /*
    Shim to make addEventListener work correctly with IE.
    */
    var addEventListener = function (el, event, eventListener) {
      // Add multiple event listeners at once if array is passed.
      if (Util.isArray(event)) {
        return Util.each(event, function (ev) {
          addEventListener(el, ev, eventListener);
        });
      }

      if (el.addEventListener) {
        el.addEventListener(event, eventListener);
      } else {
        el.attachEvent('on' + event, eventListener);
      }
    };

    /*
    Replace {{variable.name}} with it's property on the scope
    Also supports {{variable.name || another.name || 'string'}}
    */
    var insertReplacements = function (htmlStr, scope) {
     return htmlStr.replace(/\{\{(.*?)\}\}/g, function (_match, sub) {
       var tokens = sub.split('||');
       var value, token;
       while (token = tokens.shift()) {
         token = token.trim();

         // If string
         if (token[0] === '"') return token.slice(1, token.length - 1);

         // If query matches
         value =  Util.queryObject(scope, token);

         if (value) return value;
        }

        return '';
      });
    };

    /*
    Turn a string of html into DOM
    */
    var buildDom = function (htmlStr) {
     var container = document.createElement('div');
     container.innerHTML = htmlStr;
     return container.children[0];
    };

    var applyToElementsWithAttribute = function (dom, attribute, func) {
      var els = dom.parentNode.querySelectorAll('[' + attribute + ']');
      Util.each(els, function (element) {
        var attributeVal = element.getAttribute(attribute);
        func(element, attributeVal);
      }, window, true);
    };

    /*
    Parse event attributes in dom and set listeners to their matching scope methods
    */
    var applyEvents = function (dom, scope) {
     applyToElementsWithAttribute(dom, eventAttribute, function (element, attributeVal) {
       var parts = attributeVal.split(':');
       var listener = Util.queryObject(scope, parts[1]);
       addEventListener(element, parts[0], Util.bind(listener, scope));
      });
    };

    var applyConditionals = function (dom, scope) {
      applyToElementsWithAttribute(dom, conditionAttribute, function (element, attributeVal) {
        var value = Util.queryObject(scope, attributeVal);
        if (!value) {
          element.parentNode.removeChild(element);
        }
      });
    };

    return {
      build: function (htmlStr, scope) {
        if (Util.isArray(htmlStr)) htmlStr = htmlStr.join('');

        htmlStr = insertReplacements(htmlStr, scope);
        var dom = buildDom(htmlStr);
        applyEvents(dom, scope);
        applyConditionals(dom, scope);

        return dom;
      }
    };
  })();

  /*
  Plugin
  */
  var cookieconsent = {
    options: {
      message: '',
      dismiss: '',
      learnMore: '',
      padding: false,
      link: null,
      target: '_self',
      container: null, // selector
      domain: null, // default to current domain.
      path: '/',
      markup: [
        '<div class="cc-banner-wrapper {{containerClasses}}">',
          '<div class="cc-banner cc-container cc-container--open">',
            '<div class="cc-container-inner">',
              '<div class="cc-message-wrap">',
                '<p class="cc-message">{{options.message}} ',
                  '<a data-cc-if="options.link" target="{{ options.target }}" class="cc-more-info" href="{{options.link || "#null"}}">{{options.learnMore}}</a>',
                '</p>',
              '</div>',
              '<div class="cc-btn-wrap">',
                '<a href="#null" data-cc-event="click:dismiss" target="_blank" class="cc-btn cc-btn-accept-all btn">{{options.dismiss}}</a>',
              '</div>',
            '</div>',
          '</div>',
        '</div>'
      ]
    },

    init: function () {
      var options = window[OPTIONS_VARIABLE];
      if (options) this.setOptions(options);

      // if there is no read more link, display no link
      if(this.options.link === null) {
        this.options.markup[5] = '';
      }

      this.setContainer();
      this.render();
    },

    setOptionsOnTheFly: function (options) {
      this.setOptions(options);
      this.render();
    },

    setOptions: function (options) {
      Util.merge(this.options, options);
    },

    setContainer: function () {
      if (this.options.container) {
        this.container = document.querySelector(this.options.container);
      } else {
        this.container = document.body;
      }

      // Add class to container classes so we can specify css for IE8 only.
      this.containerClasses = '';
      if (navigator.appVersion.indexOf('MSIE 8') > -1) {
        this.containerClasses += ' cc_ie8'
      }
    },

    render: function () {
      // remove current element (if we've already rendered)
      if (this.element && this.element.parentNode) {
        this.element.parentNode.removeChild(this.element);
        delete this.element;
      }

      this.element = DomBuilder.build(this.options.markup, this);
      if (!this.container.firstChild) {
        this.container.appendChild(this.element);
      } else {
        this.container.insertBefore(this.element, this.container.firstChild);
      }

      document.body.classList.add("cc-is-visible");
      if (this.options.padding) {
        var cc_height = document.getElementsByClassName('cc-banner')[0].offsetHeight;
        document.body.style.paddingBottom = cc_height + 'px';
      }

      var domRect = this.container.firstChild.getBoundingClientRect();
    },

    dismiss: function (evt) {
      evt.preventDefault && evt.preventDefault();
      evt.returnValue = false;
      this.setMessageDismissed();

      // animate disappearing
      this.element.classList.add('dismissed');

      // give this scope to anonymous function
      var temp = this;

      // remove the whole element after animation is completed (0.1s safe time)
      setTimeout(function(){ temp.container.removeChild(temp.element); },500);

      document.body.classList.remove("cc-is-visible");
      if (this.options.padding) {
        document.body.style.paddingBottom = '0px';
      }

    },

    setMessageDismissed: function () {
      Util.setLocalStorage(MESSAGE_DISMISSED, 'yes');
    }
  };

  var init;
  var initialized = false;
  (init = function () {
    if (!initialized && document.readyState == 'complete') {
      cookieconsent.init();
      initialized = true;
      window[OPTIONS_UPDATER] = Util.bind(cookieconsent.setOptionsOnTheFly, cookieconsent);
    }
  })();

  Util.addEventListener(document, 'readystatechange', init);

})();
